import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, ArrowUpRight } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-[#0B1F35] text-slate-300">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-20 pb-10">
        <div className="grid lg:grid-cols-12 gap-12 pb-16 border-b border-white/10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <img
                src="/favicon.png"
                alt="Waypoint Transformation"
                className="w-12 h-12 rounded-sm"
              />
              <div className="leading-[1.05]">
                <div className="font-serif text-white text-[22px] tracking-[-0.01em]">Waypoint Transformation LLC</div>
                <div className="text-[10px] uppercase tracking-[0.2em] text-slate-400 mt-1">Collaboration · Trust · Execution · Integrity</div>
              </div>
            </div>
            <p className="text-slate-400 leading-relaxed max-w-md text-[15px]">
              Experienced fractional technology leadership and global transformation delivery for organizations that are ready to move with confidence.
            </p>
            <Link to="/contact" className="inline-flex items-center gap-2 mt-8 text-white text-sm font-medium border-b border-white/40 pb-1 hover:border-white transition-colors">
              Start a conversation <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>

          <div className="lg:col-span-3">
            <div className="text-white text-[13px] font-semibold uppercase tracking-[0.15em] mb-5">Services</div>
            <ul className="space-y-3 text-sm">
              <li><Link to="/services#fractional-cio" className="hover:text-white transition-colors">Fractional CIO</Link></li>
              <li><Link to="/services#engineering-leadership" className="hover:text-white transition-colors">Engineering Leadership</Link></li>
              <li><Link to="/services#fractional-cto" className="hover:text-white transition-colors">Fractional CTO</Link></li>
              <li><Link to="/services#program-management" className="hover:text-white transition-colors">Program Management</Link></li>
              <li><Link to="/services#global-transformation" className="hover:text-white transition-colors">Global Transformation</Link></li>
              <li><Link to="/services#interim-leadership" className="hover:text-white transition-colors">Interim Leadership</Link></li>
              <li><Link to="/services#ai-transformation" className="hover:text-white transition-colors">AI Transformation</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="text-white text-[13px] font-semibold uppercase tracking-[0.15em] mb-5">Company</div>
            <ul className="space-y-3 text-sm">
              <li><Link to="/about" className="hover:text-white transition-colors">About</Link></li>
              <li><Link to="/insights" className="hover:text-white transition-colors">Insights</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="text-white text-[13px] font-semibold uppercase tracking-[0.15em] mb-5">Contact</div>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-slate-500" /><span>Chicago, IL<br/><span className="text-slate-500 text-xs">Serving clients globally</span></span></li>
              <li className="flex items-start gap-2"><Phone className="w-4 h-4 mt-0.5 text-slate-500" /><a href="tel:16304479380" className="hover:text-white">1-630-447-9380</a></li>
              <li className="flex items-start gap-2"><Mail className="w-4 h-4 mt-0.5 text-slate-500" /><a href="mailto:info@waypointtransformation.com" className="hover:text-white">info@waypointtransformation.com</a></li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 pt-8 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} Waypoint Transformation LLC. All rights reserved.</div>
          <div className="flex gap-6">
            <span>Privacy</span>
            <span>Terms</span>
            <span>Accessibility</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
